import { render, staticRenderFns } from "./DocumentSlider.vue?vue&type=template&id=1331d2e4&scoped=true"
import script from "./DocumentSlider.ts?vue&type=script&lang=ts&external"
export * from "./DocumentSlider.ts?vue&type=script&lang=ts&external"
import style0 from "./DocumentSlider.scss?vue&type=style&index=0&id=1331d2e4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331d2e4",
  null
  
)

export default component.exports